// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvatarUpload-space1-lrv7E {
	margin-bottom: 6px !important;
}

.AvatarUpload-space2-BQI9v {
	margin-bottom: 12px !important;
}

.AvatarUpload-space3-uy7dT {
	margin-bottom: 18px !important;
}

.AvatarUpload-space4-dpDXZ {
	margin-bottom: 24px !important;
}

.AvatarUpload-space5-dPSke {
	margin-bottom: 30px !important;
}

.AvatarUpload-space6-E5wXM {
	margin-bottom: 36px !important;
}

.AvatarUpload-space7-KvNZq {
	margin-bottom: 42px !important;
}

.AvatarUpload-spaceTop8-ie01Y {
	margin-bottom: 48px !important;
}

.AvatarUpload-spaceTop1-gNZvp {
	margin-top: 6px !important;
}

.AvatarUpload-spaceTop2-TC70a {
	margin-top: 12px !important;
}

.AvatarUpload-spaceTop3-K9n1p {
	margin-top: 18px !important;
}

.AvatarUpload-spaceTop4-g5r8o {
	margin-top: 24px !important;
}

.AvatarUpload-spaceTop5-TXkOh {
	margin-top: 30px !important;
}

.AvatarUpload-spaceTop6-DlVXh {
	margin-top: 36px !important;
}

.AvatarUpload-spaceTop7-oqwbx {
	margin-top: 42px !important;
}

.AvatarUpload-spaceTop8-ie01Y {
	margin-top: 48px !important;
}

.AvatarUpload-noMargin-x_FlK {
	margin: 0px !important;
}

.AvatarUpload-padding1-DGqso {
	padding-bottom: 6px !important;
}

.AvatarUpload-padding2-EpZ29 {
	padding-bottom: 12px !important;
}

.AvatarUpload-padding3-UUABf {
	padding-bottom: 18px !important;
}

.AvatarUpload-padding4-veAY6 {
	padding-bottom: 24px !important;
}

.AvatarUpload-padding5-WTdGa {
	padding-bottom: 30px !important;
}

.AvatarUpload-padding6-JZKYY {
	padding-bottom: 36px !important;
}

.AvatarUpload-padding7-GAfEN {
	padding-bottom: 42px !important;
}

.AvatarUpload-paddingTop1-siTfl {
	padding-top: 6px !important;
}

.AvatarUpload-paddingTop2-sl1Ia {
	padding-top: 12px !important;
}

.AvatarUpload-paddingTop3-s62mf {
	padding-top: 18px !important;
}

.AvatarUpload-paddingTop4-ZQWwN {
	padding-top: 24px !important;
}

.AvatarUpload-paddingTop5-cvkaV {
	padding-top: 30px !important;
}

.AvatarUpload-paddingTop6-kTUw0 {
	padding-top: 36px !important;
}

.AvatarUpload-paddingTop7-cAGsz {
	padding-top: 42px !important;
}

.AvatarUpload-noPadding-uNm1f {
	padding: 0px !important;
}

.AvatarUpload-textBold-ul4B2 {
	font-weight: 500 !important;
}

.AvatarUpload-textBolder-YzP7A {
	font-weight: 700 !important;
}

.AvatarUpload-textNormal-Y2y4f {
	font-weight: normal !important;
}

.AvatarUpload-spaceBottom20-xUi6B {
	margin-bottom: 20px;
}

.AvatarUpload-spaceBottom10-fI_D5 {
	margin-bottom: 10px;
}

.AvatarUpload-marginNone-sOOnc {
	margin: 0;
}

.AvatarUpload-spaceBottom15-wviFe {
	margin-bottom: 15px;
}

.AvatarUpload-marginTopNone-sYHZl {
	margin-top: 0;
}

.AvatarUpload-spaceTop11-IOA3j {
	margin-top: 11px;
}

.AvatarUpload-spaceTop21-hxp63 {
	margin-top: 21px;
}

.AvatarUpload-spaceTop20-MffAf {
	margin-top: 20px;
}

.AvatarUpload-spaceTop10-y5xwz {
	margin-top: 10px;
}

/*New Design Text Colors */

.AvatarUpload-textDarkBlue-yBcmF {
	color: rgb(20, 39, 94) !important;
}

.AvatarUpload-textLightBlue-Sbbvo {
	color: rgb(57, 87, 106) !important;
}

.AvatarUpload-textLightSandleGreen-HLB_q {
	color: rgb(76, 86, 41) !important;
}

.AvatarUpload-textLightBrown-PmgsI {
	color: rgb(115, 79, 33) !important;
}

.AvatarUpload-textMediumMaroon-NjlMS {
	color: rgb(87, 37, 51) !important;
}

.AvatarUpload-textBrown-vZal2 {
	color: rgb(160, 47, 24) !important;
}

.AvatarUpload-textMaroon-tp2Pf {
	color: rgb(155, 49, 67) !important;
}

.AvatarUpload-textDarkBrown-Txkab {
	color: rgb(83, 18, 16) !important;
}

.AvatarUpload-textMediumBrown-AKyfV {
	color: rgb(142, 28, 10) !important;
}

.AvatarUpload-textSkyBlue-oI0B1 {
	color: rgb(37, 117, 141) !important;
}

.AvatarUpload-textGray-OzUwL {
	color: rgb(77, 65, 51) !important;
}

.AvatarUpload-button-jziyj {
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin: 0;
  padding: 10px 16px;
  width: 100%;
  outline: 0;
  border: 1px solid var(--primary-bg);
  border-radius: 4px;
  background: var(--primary-bg);
  color: var(var(--primary-foreground));
  text-align: center;
  text-decoration: none;
  font-size: 18px;
  line-height: 1.3333333;
  cursor: pointer;
}

.AvatarUpload-button-jziyj:hover {
  background: var(--primary-bg);
}

.AvatarUpload-noMargin-x_FlK {
  margin: 0px;
}

.AvatarUpload-noBorder-o3Ew5 {
  border: 0px none !important;
}

.AvatarUpload-activationStepPanel-RJlWV {
  max-width: 530px;
  margin: 0 auto;
  height: 100%;
  min-height: 520px;
  text-align: center;
  border: none;
}

.AvatarUpload-panelBody-rEuFl {
  position: relative;
  padding-top: 35px;
  padding-bottom: 35px;
  padding-left: 60px;
  padding-right: 60px;
}

a,
a:hover,
a:focus,
a:active {
  color: var(--primary-link-foreground);
  text-decoration: none;
}

.AvatarUpload-profileImage-Fypa3 {
  height: 130px;
  width: 130px;
}

.AvatarUpload-mediaPhoto-Wuow9 {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  overflow: hidden;
}

.AvatarUpload-mediaRound-Md2Tf {
  border-radius: 50%;
  border: 2px solid var(--primary-border);
}

.AvatarUpload-btnlarge-BYxZU {
  padding: 7px 0px !important;
}

@media screen and (max-width:767px) {
  .AvatarUpload-profileImage-Fypa3 {
    height: 110px;
    width: 110px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Booking/common.css","webpack://./src/components/Booking/AvatarUpload/AvatarUpload.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;EACE,cAAc;EACd,8BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AC3BA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;EAIE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.button {\n  display: block;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 10px 16px;\n  width: 100%;\n  outline: 0;\n  border: 1px solid var(--primary-bg);\n  border-radius: 4px;\n  background: var(--primary-bg);\n  color: var(var(--primary-foreground));\n  text-align: center;\n  text-decoration: none;\n  font-size: 18px;\n  line-height: 1.3333333;\n  cursor: pointer;\n}\n\n.button:hover {\n  background: var(--primary-bg);\n}\n\n.noMargin {\n  margin: 0px;\n}\n\n.noBorder {\n  border: 0px none !important;\n}","@import '../common.css';\n@import '../../helpers.css';\n\n.activationStepPanel {\n  max-width: 530px;\n  margin: 0 auto;\n  height: 100%;\n  min-height: 520px;\n  text-align: center;\n  border: none;\n}\n\n.panelBody {\n  position: relative;\n  padding-top: 35px;\n  padding-bottom: 35px;\n  padding-left: 60px;\n  padding-right: 60px;\n}\n\na,\na:hover,\na:focus,\na:active {\n  color: var(--primary-link-foreground);\n  text-decoration: none;\n}\n\n.profileImage {\n  height: 130px;\n  width: 130px;\n}\n\n.mediaPhoto {\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  overflow: hidden;\n}\n\n.mediaRound {\n  border-radius: 50%;\n  border: 2px solid var(--primary-border);\n}\n\n.btnlarge {\n  padding: 7px 0px !important;\n}\n\n@media screen and (max-width:767px) {\n  .profileImage {\n    height: 110px;\n    width: 110px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AvatarUpload-space1-lrv7E`,
	"space2": `AvatarUpload-space2-BQI9v`,
	"space3": `AvatarUpload-space3-uy7dT`,
	"space4": `AvatarUpload-space4-dpDXZ`,
	"space5": `AvatarUpload-space5-dPSke`,
	"space6": `AvatarUpload-space6-E5wXM`,
	"space7": `AvatarUpload-space7-KvNZq`,
	"spaceTop8": `AvatarUpload-spaceTop8-ie01Y`,
	"spaceTop1": `AvatarUpload-spaceTop1-gNZvp`,
	"spaceTop2": `AvatarUpload-spaceTop2-TC70a`,
	"spaceTop3": `AvatarUpload-spaceTop3-K9n1p`,
	"spaceTop4": `AvatarUpload-spaceTop4-g5r8o`,
	"spaceTop5": `AvatarUpload-spaceTop5-TXkOh`,
	"spaceTop6": `AvatarUpload-spaceTop6-DlVXh`,
	"spaceTop7": `AvatarUpload-spaceTop7-oqwbx`,
	"noMargin": `AvatarUpload-noMargin-x_FlK`,
	"padding1": `AvatarUpload-padding1-DGqso`,
	"padding2": `AvatarUpload-padding2-EpZ29`,
	"padding3": `AvatarUpload-padding3-UUABf`,
	"padding4": `AvatarUpload-padding4-veAY6`,
	"padding5": `AvatarUpload-padding5-WTdGa`,
	"padding6": `AvatarUpload-padding6-JZKYY`,
	"padding7": `AvatarUpload-padding7-GAfEN`,
	"paddingTop1": `AvatarUpload-paddingTop1-siTfl`,
	"paddingTop2": `AvatarUpload-paddingTop2-sl1Ia`,
	"paddingTop3": `AvatarUpload-paddingTop3-s62mf`,
	"paddingTop4": `AvatarUpload-paddingTop4-ZQWwN`,
	"paddingTop5": `AvatarUpload-paddingTop5-cvkaV`,
	"paddingTop6": `AvatarUpload-paddingTop6-kTUw0`,
	"paddingTop7": `AvatarUpload-paddingTop7-cAGsz`,
	"noPadding": `AvatarUpload-noPadding-uNm1f`,
	"textBold": `AvatarUpload-textBold-ul4B2`,
	"textBolder": `AvatarUpload-textBolder-YzP7A`,
	"textNormal": `AvatarUpload-textNormal-Y2y4f`,
	"spaceBottom20": `AvatarUpload-spaceBottom20-xUi6B`,
	"spaceBottom10": `AvatarUpload-spaceBottom10-fI_D5`,
	"marginNone": `AvatarUpload-marginNone-sOOnc`,
	"spaceBottom15": `AvatarUpload-spaceBottom15-wviFe`,
	"marginTopNone": `AvatarUpload-marginTopNone-sYHZl`,
	"spaceTop11": `AvatarUpload-spaceTop11-IOA3j`,
	"spaceTop21": `AvatarUpload-spaceTop21-hxp63`,
	"spaceTop20": `AvatarUpload-spaceTop20-MffAf`,
	"spaceTop10": `AvatarUpload-spaceTop10-y5xwz`,
	"textDarkBlue": `AvatarUpload-textDarkBlue-yBcmF`,
	"textLightBlue": `AvatarUpload-textLightBlue-Sbbvo`,
	"textLightSandleGreen": `AvatarUpload-textLightSandleGreen-HLB_q`,
	"textLightBrown": `AvatarUpload-textLightBrown-PmgsI`,
	"textMediumMaroon": `AvatarUpload-textMediumMaroon-NjlMS`,
	"textBrown": `AvatarUpload-textBrown-vZal2`,
	"textMaroon": `AvatarUpload-textMaroon-tp2Pf`,
	"textDarkBrown": `AvatarUpload-textDarkBrown-Txkab`,
	"textMediumBrown": `AvatarUpload-textMediumBrown-AKyfV`,
	"textSkyBlue": `AvatarUpload-textSkyBlue-oI0B1`,
	"textGray": `AvatarUpload-textGray-OzUwL`,
	"button": `AvatarUpload-button-jziyj`,
	"noBorder": `AvatarUpload-noBorder-o3Ew5`,
	"activationStepPanel": `AvatarUpload-activationStepPanel-RJlWV`,
	"panelBody": `AvatarUpload-panelBody-rEuFl`,
	"profileImage": `AvatarUpload-profileImage-Fypa3`,
	"mediaPhoto": `AvatarUpload-mediaPhoto-Wuow9`,
	"mediaRound": `AvatarUpload-mediaRound-Md2Tf`,
	"btnlarge": `AvatarUpload-btnlarge-BYxZU`
};
module.exports = ___CSS_LOADER_EXPORT___;
